module.exports = __webpack_public_path__ + "static/media/bgd1@2x.6946c73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/bgd1@2x.png
// module id = 339
// module chunks = 0